
import { Apple } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { useNavigate } from "react-router-dom";
import { useTranslations } from "@/hooks/useTranslations";
import { useLanguagePath } from "@/utils/language";

export const NutritionHeader = () => {
  const navigate = useNavigate();
  const { t } = useTranslations("nutrition");
  const { getPath } = useLanguagePath();
  
  return <div className="space-y-4 animate-fade-in">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pb-4 border-b border-slate-100/50 dark:border-gray-700/50">
        <div className="space-y-2 w-full">
          <h2 className="text-3xl font-bold tracking-tight gradient-text dark:text-white">{t("title")}</h2>
          <p className="text-muted-foreground dark:text-gray-300">{t("subtitle")}</p>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={getPath("/student-dashboard")} className="text-flame hover:text-flame/80">{t("breadcrumbs.dashboard")}</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="font-medium dark:text-gray-200">{t("breadcrumbs.nutrition")}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </div>
    </div>;
};
